import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const FootballIcon = observer('FootballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='footballMask'
                width='20'
                height='20'
                x='-2'
                y='-2'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#1c1b1f'
                    d='m6.263 16.21.316-1.473q.079-.342.329-.566t.618-.276l3.264-.263a.9.9 0 0 1 .631.131q.29.185.421.5l.421 1a8.5 8.5 0 0 0 3.21-3.368l-.315-.158a1.24 1.24 0 0 1-.421-.513 1 1 0 0 1-.053-.645l.737-3.21a1 1 0 0 1 .329-.527 1.16 1.16 0 0 1 .566-.263 12 12 0 0 0-.33-1.276 7 7 0 0 0-.512-1.198.94.94 0 0 1-.514.119.86.86 0 0 1-.486-.171l-2.79-1.685a1.07 1.07 0 0 1-.42-.5 1.05 1.05 0 0 1-.053-.657l.21-.895A8.3 8.3 0 0 0 9.75-.237 8.3 8.3 0 0 0 8-.42a7.7 7.7 0 0 0-1.526.158l.79 1.79q.13.316.065.657A.9.9 0 0 1 7 2.737L4.526 4.895a1 1 0 0 1-.618.263A1.03 1.03 0 0 1 3.263 5L.843 3.526a8.8 8.8 0 0 0-.935 2.145A8.4 8.4 0 0 0-.422 8q0 .42.106 1.368L2 9.158a1.01 1.01 0 0 1 1.105.631l1.263 3q.132.316.066.658a.9.9 0 0 1-.329.553l-1 .842q.71.526 1.513.868a8 8 0 0 0 1.645.5m1.895-4.526a.9.9 0 0 1-.632-.131 1.07 1.07 0 0 1-.42-.5L5.683 7.789a1 1 0 0 1-.04-.657A1.03 1.03 0 0 1 6 6.579l2.684-2.263a.9.9 0 0 1 .58-.263q.341-.027.63.158l2.948 1.736q.29.185.447.5.159.316.08.658l-.843 3.421a1.1 1.1 0 0 1-.316.566q-.236.224-.578.276zM8.002 18a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.176-2.138 10.1 10.1 0 0 1-2.138-3.174A9.7 9.7 0 0 1-2 8.001q0-2.073.787-3.9A10.1 10.1 0 0 1 .924.927 10.1 10.1 0 0 1 4.1-1.212 9.7 9.7 0 0 1 7.999-2q2.073 0 3.9.787A10.1 10.1 0 0 1 15.073.924 10.1 10.1 0 0 1 17.212 4.1a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.787 3.9 10.1 10.1 0 0 1-2.138 3.175 10.1 10.1 0 0 1-3.174 2.138 9.7 9.7 0 0 1-3.9.788'
                />
            </mask>
            <g mask='url(#footballMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
